<template>
  <div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn
          class="mx-2"
          fab
          x-small
          color="accent"
          @click="handleFileImport"
          :loading="isSelecting"
          v-on="on"
        >
          <v-icon dark>mdi-file-import</v-icon>
        </v-btn>
      </template>
      <span>{{ $t("formula.import.importCSV") }}</span>
    </v-tooltip>

    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn
          class="mx-2"
          fab
          x-small
          color="accent"
          @click="handleFileDownload"
          v-on="on"
        >
          <v-icon dark>mdi-download</v-icon>
        </v-btn>
      </template>
      <span>{{ $t("formula.import.download") }}</span>
    </v-tooltip>
    <input
      ref="fileInputRef"
      type="file"
      accept=".csv"
      class="d-none"
      @change="onSelectedFile"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { saveAs } from "file-saver";
import {
  defaultFormulaHeaderEntry,
  defaultFormulaVariableEntry,
} from "../../../_helpers/formulaHelper";

export default {
  name: "FormulaCsv",

  props: {
    value: {
      type: Array,
      default: () => [],
    },

    variableNames: {
      type: Array,
      default: () => [],
    },
  },

  model: {
    prop: "value",
  },

  data() {
    return {
      file: null,
      isSelecting: false,
    };
  },

  computed: {
    localValue: {
      get() {
        return this.value;
      },

      set(val) {
        this.$emit("input", val);
      },
    },

    formulaHeaderSize() {
      return Object.keys(defaultFormulaHeaderEntry).length;
    },
  },

  methods: {
    ...mapActions("alert", ["success", "error"]),

    handleFileImport() {
      this.isSelecting = true;

      // After obtaining the focus when closing the FilePicker, return the button state to normal
      window.addEventListener(
        "focus",
        () => {
          this.isSelecting = false;
        },
        { once: true }
      );

      this.$refs.fileInputRef.click();
    },

    handleFileDownload() {
      if (this.localValue.length == 0) {
        this.error(this.$t("formula.errors.csvOutput"));
        return;
      }

      let csvRows = [];
      csvRows.push(Object.keys(this.localValue.at(0)).join(","));
      for (var formula of this.localValue) {
        csvRows.push(Object.values(formula).join(","));
      }
      if (csvRows.length < 2) {
        this.error(this.$t("formula.errors.csvOutput"));
        return;
      }
      saveAs(
        new Blob([csvRows.join("\n")], { type: "text/csv" }),
        `Formulas.csv`
      );
    },

    onSelectedFile(e) {
      this.file = e.target.files[0];

      // Reader
      let reader = new FileReader();
      reader.onload = (res) => {
        let args = res.target.result.split(/\r?\n/);
        if (args < 2) {
          this.error(this.$t("formula.errors.csvInput"));
          return;
        }

        let formulas = [];
        let varHeaders = Object.keys(defaultFormulaVariableEntry);
        for (var a of args.slice(1, args.length)) {
          let parts = a.split(",");
          if (
            parts.length <
            this.formulaHeaderSize +
              this.variableNames.length * this.variableSize
          ) {
            this.error(this.$t("formula.errors.csvInput"));
            continue;
          }

          let formula = {};
          {
            let i = 0;
            Object.keys(defaultFormulaHeaderEntry).forEach((x) => {
              formula[x] = parts[i];
              i++;
            });
          }

          for (let i = 0; i < this.variableNames.length; i++) {
            let k = 0;
            varHeaders.forEach((y) => {
              let val =
                parts[this.formulaHeaderSize + i * varHeaders.length + k];
              if (val.toLowerCase() === "true" || val.toLowerCase() === "false")
                val = val.toLowerCase() === "true";
              formula[`${this.variableNames[i]}-${y}`] = val;
              k++;
            });
          }
          formulas.push(formula);
        }
        this.localValue = formulas;
        this.$emit("updateKeys");
      };
      reader.onerror = () => this.error(this.$t("formula.errors.upload"));
      reader.readAsText(this.file);
    },
  },
};
</script>
